import { render, staticRenderFns } from "./rduserupload-add-or-update.vue?vue&type=template&id=5c6b5fd4&"
import script from "./rduserupload-add-or-update.vue?vue&type=script&lang=js&"
export * from "./rduserupload-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports